export default __webpack_public_path__ + "static/media/Flag_of_India.aa3012ad.png";